import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppDispatch } from '../store';
import { logout } from '../store/slices/authSlice';

const SESSION_TIMEOUT = 30 * 60 * 1000; // 30分
const WARNING_BEFORE_TIMEOUT = 5 * 60 * 1000; // 5分前に警告

export const useSessionTimeout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const timeoutId = useRef<NodeJS.Timeout>();
  const warningTimeoutId = useRef<NodeJS.Timeout>();

  const resetTimeout = () => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    if (warningTimeoutId.current) {
      clearTimeout(warningTimeoutId.current);
    }

    warningTimeoutId.current = setTimeout(() => {
      // セッション切れ5分前に警告を表示
      const event = new CustomEvent('session-warning', {
        detail: {
          message: 'セッションの有効期限が切れる5分前です。継続して利用する場合は画面を操作してください。',
        },
      });
      window.dispatchEvent(event);
    }, SESSION_TIMEOUT - WARNING_BEFORE_TIMEOUT);

    timeoutId.current = setTimeout(async () => {
      await dispatch(logout());
      localStorage.removeItem('accessToken');
      navigate('/login', { replace: true });
      
      const event = new CustomEvent('session-expired', {
        detail: {
          message: 'セッションの有効期限が切れました。再度ログインしてください。',
        },
      });
      window.dispatchEvent(event);
    }, SESSION_TIMEOUT);
  };

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      resetTimeout();

      const events = [
        'mousedown',
        'keydown',
        'scroll',
        'touchstart',
        'mousemove',
      ];

      const handleActivity = () => {
        resetTimeout();
      };

      events.forEach(event => {
        document.addEventListener(event, handleActivity);
      });

      return () => {
        if (timeoutId.current) {
          clearTimeout(timeoutId.current);
        }
        if (warningTimeoutId.current) {
          clearTimeout(warningTimeoutId.current);
        }
        events.forEach(event => {
          document.removeEventListener(event, handleActivity);
        });
      };
    }
  }, [dispatch, navigate]);

  return { resetTimeout };
}; 